import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Keycloak from "keycloak-js";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import 'leaflet/dist/leaflet.css';

import Vuex from 'vuex';

Vue.use(axios);
Vue.use(Vuex);
Vue.use(ElementUI); 
axios.defaults.baseURL = process.env.VUE_APP_API;

// Fix missing leaflet icons
import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


Vue.config.productionTip = false

const keycloak = new Keycloak({
  url: process.env.VUE_APP_KEYCLOAK_AUTH,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT,
  onLoad: "login-required"
});

keycloak
  .init({
    onLoad: "login-required",
    checkLoginIframe: false
  })
  .then(auth => {
    //set initial token
    axios.defaults.headers.common["Authorization"] = keycloak.token;
    store.dispatch("storeUserInfo", {
      token: keycloak.token,
      parsedToken: keycloak.tokenParsed
    });

    // check every minute if token has at least 120 seconds of validity, if not, refresh
    setInterval(() => {
      // refresh keycloaks token
      keycloak
        .updateToken(120)
        .then(refreshed => {
          if (refreshed) {
            console.info("[KEYCLOAK] Refreshed token");
            store.dispatch("storeUserInfo", {
              token: keycloak.token,
              parsedToken: keycloak.tokenParsed
            });
            axios.defaults.headers.common["Authorization"] = keycloak.token; // set refreshed token
          }
        })
        .catch(e => {
          console.info("[KEYCLOAK] Error refreshing token");
        });

      // if token wasn't refreshed and it expired then logout
      if (keycloak.isTokenExpired()) {
        keycloak.logout();
      }
    }, 60000);
    Vue.prototype.$logout = keycloak.logout;
    Vue.prototype.$width =
      window.innerWidth > 0 ? window.innerWidth : screen.width;

    // mount alertMessage component
    // const alertMsg = new Vue(alertMessage).$mount();
    // Vue.prototype.$message = alertMsg.show;
    // document.body.appendChild(alertMsg.$el);

    // functions to excecute on every axios request
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 457) {
          keycloak.logout();
        }
        return Promise.reject(error);
      }
    );
    Vue.prototype.$axios = axios;

    const vm = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  })
  .catch(e => {
    console.log(e);
  });
